// extracted by mini-css-extract-plugin
export default {"main_card":"ProductCard_main_card__Wt+6J","card_action":"ProductCard_card_action__yEEjM","cart_box":"ProductCard_cart_box__TC49M","cart_img":"ProductCard_cart_img__qBgMn"};